import React from 'react';
import {CurrencyValue} from '../../../src/models/interfaces';
import {useApis} from '../apis/ApisContext';

interface CurrencyProps {
  value?: null | CurrencyValue;
}

export const Currency: React.FC<CurrencyProps> = React.memo(({value}) => {
  const {t} = useApis();
  return (
    <>
      {value?.val && value?.unit
        ? t({
            type: 'ValueUnit',
            val: value.val,
            unit: value.unit,
          })
        : '-'}
    </>
  );
});
